import { commonLang } from '@umu/ukit-lang';
/*
 * @Author: zhaihaooran
 * @Date: 2021-07-03 15:49:59
 * @LastEditors: OBKoro1
 * @FilePath: /umu_mobile/src/businessCommon/components/wxShare/wxShare.tsx
 */
/*
 * @author: wayou
 * @date: 2018-10-09 10:09:44
 * @description: 微信分享浮层
 * usage:
 * <WxShare/>
 * or
 * <WxShare
 *     content = {'<h1>here goes your content</h1>'}
 *     label = "点击邀请朋友分享"
 * />
 */

import React, { Component } from 'react';
import umuWebview from '@umu/umu-webview';
import imageApi from '@umu/umu-image-handle';
import { IShareConfig } from '@umu/umu-types';
import arrowIcon from './images/arrow.png';

import './wxShare.scss';
import { isFromCourseMiniApp } from '../../@utils/umuUtil';

interface IWxShareProps {
    content?: string;
    label?: string;
    noShare?: boolean;
    shareOption?: IShareConfig;
    callBack?: () => void; // 点击分享后的回调，例如埋点
}

export default class WxShare extends Component<IWxShareProps, {}> {
    private originalOverflowVal: string | null = null;
    private defaultContent: string = `
        <img class="share-arrow" src="${imageApi.process(arrowIcon)}" />
        <p class="share-info">${commonLang('点这里分享，')}<br/>${commonLang('让更多人感受知识的力量')}</p>
    `;

    constructor(props: IWxShareProps) {
        super(props);
        this.toggleShare = this.toggleShare.bind(this);
    }

    public componentDidMount() {
        // 保存 body 原来的 overflow 属性值
        if (this.originalOverflowVal == null) {
            this.originalOverflowVal = document.body.style.overflow;
        }
    }

    public toggleShare(_event: React.SyntheticEvent) {
        const { callBack: cb, shareOption: shareOptions } = this.props;
        // 如果是在 app 中打开则直接调用 app 的分享方法
        if (umuWebview && umuWebview.UA_INFO.isUMUWebview) {
            if (shareOptions) {
                umuWebview.callHandler('callShare', shareOptions);
            }
            if (typeof cb === 'function') {
                cb();
            }
            return;
        }

        document.body.style.overflow = 'hidden';

        const overlay = document.createElement('div');
        overlay.className = 'wx-share-overlay';
        overlay.style.display = 'block';
        overlay.onclick = () => {
            document.body.removeChild(overlay);
            // @ts-ignore
            document.body.style.overflow = this.originalOverflowVal;
        };
        overlay.innerHTML = this.props.content || this.defaultContent;
        document.body.appendChild(overlay);
        if (typeof cb === 'function') {
            cb();
        }
    }

    public render() {
        if (
            this.props.noShare ||
            !(umuWebview.UA_INFO.isWeixinBrowser || umuWebview.UA_INFO.isUMUWebview) ||
            isFromCourseMiniApp()
        ) {
            return null;
        }

        return (
            <div className="wx-share" onClick={this.toggleShare}>
                <div className="wx-share-icon">
                    <i className="icon-share" />
                    {this.props.label}
                </div>
            </div>
        );
    }
}
